import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import createAddAthleteSchema from "./schemas/addAthleteSchema";

import AddAthleteInput from "./components/AddAthleteInput";
import Button from "../../components/Button";

import { editAthletes } from "./api/athleteRequests";
import { useTranslation } from "../../i18n/TranslationProvider";

function EditRoster() {
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const { state } = useLocation();
    const navigate = useNavigate();
    const athlete = state.athlete || [];
    const athleteInfo = athlete.athlete_info;
    const { t } = useTranslation();

    const addAthleteSchema = useMemo(() => createAddAthleteSchema(t), [t]);

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(addAthleteSchema),
        defaultValues: { athletes: [athlete.athlete_info] },
    });

    const onSubmit = async (data) => {
        try {
            const formData = data.athletes[0];
            const athleteId = athlete.athlete_id;
            await editAthletes({ ...formData, athleteId });
            setError("");
            setMessage(t("athletes.editSuccess"));
        } catch (err) {
            console.error("EditRoster onSubmit error", err);
            setMessage("");
            setError(t("athletes.editErrorGeneric"));
        }
    };

    return (
        <div className="custom-container mx-auto w-4/5 lg:w-1/2">
            <h4 className="text-lg mb-6 md:text-2xl">
                {t("athletes.editingDataFor", {
                    firstName: athleteInfo.first_name,
                    lastName: athleteInfo.last_name,
                })}
            </h4>
            <form onSubmit={handleSubmit(onSubmit)}>
                <AddAthleteInput
                    index={0}
                    register={register}
                    errors={errors}
                />
                {error && <p className="text-red-600 mb-2">{error}</p>}
                {message && <p className="text-teal-600 mb-4">{message}</p>}
                <Button
                    type="submit"
                    isLoading={isSubmitting}
                    className="w-full mt-4"
                >
                    {t("athletes.saveChanges")}
                </Button>
                <Button
                    onClick={() => navigate(-1)}
                    variant="outline"
                    className="w-full mt-2"
                >
                    {t("auth.back")}
                </Button>
            </form>
        </div>
    );
}

export default EditRoster;